const STORAGE_KEY = "tzuchi-class-management"

const getStoredClasses = () => {
  try {
    const savedClasses = JSON.parse(localStorage.getItem(STORAGE_KEY))
    return Array.isArray(savedClasses) ? savedClasses : []
  } catch (error) {
    return []
  }
}

export const addClass = classData => {
  const classes = getStoredClasses()
  const newClass = {
    ...classData,
    id: `CLS-${Date.now()}`,
    updatedAt: new Intl.DateTimeFormat("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(new Date()),
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify([newClass, ...classes]))
  return newClass
}
